import { ReactComponent as ActionDeleteIcon } from '@epam/assets/icons/common/action-delete-18.svg';
import { IconButton } from '@epam/promo';
import { UserManagementControlProps } from './UserManagementControl.model';

export const UserManagementControl = ({
  handleDelete,
}: UserManagementControlProps) => (
  <IconButton
    icon={ActionDeleteIcon}
    onClick={(e) => {
      e.stopPropagation();
      handleDelete();
    }}
  />
);
